import TextBox from "../../componets/TextBox";
import designData from "../../data/uiAndUxDesign2.json";

export default function Section4() {
  return (
    <div className="Section4">
      <div className="w-[90%] my-[24px] md:mb-0 md:w-[61%] mx-auto text-center">
        <h2 className="mx-auto text-center text-[24px] leading-[32px] md:text-[34px] font-bold md:leading-[41px] text-[#151515] mt-[40px]">
          Our <span className="text-[#DA2128]">UI/UX Design</span> Services
        </h2>
      </div>

      <TextBox
        data={designData}
        oddStyle="bg-[#f5f5f5] text-[#373737]"
        evenStyle="bg-[#f5f5f5] text-[#373737]"
      />
    </div>
  );
}
